"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EnvironmentEnum;
(function (EnvironmentEnum) {
    EnvironmentEnum[EnvironmentEnum["LIVE"] = 0] = "LIVE";
    EnvironmentEnum[EnvironmentEnum["STAGING"] = 1] = "STAGING";
})(EnvironmentEnum = exports.EnvironmentEnum || (exports.EnvironmentEnum = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZW52aXJvbm1lbnQuZW51bS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9lbnVtcy9lbnZpcm9ubWVudC5lbnVtLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsSUFBWSxlQUdYO0FBSEQsV0FBWSxlQUFlO0lBQ3pCLHFEQUFJLENBQUE7SUFDSiwyREFBTyxDQUFBO0FBQ1QsQ0FBQyxFQUhXLGVBQWUsR0FBZix1QkFBZSxLQUFmLHVCQUFlLFFBRzFCIn0=